<div class="iframe-overlay">
  <div class="iframe-container">

    <div class="iframe-header">
      <div class="header-left">
        <!-- <div class="logo-dot">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M4 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4V3z" fill="white" />
          </svg>
        </div> -->
        <span class="iframe-title iframe-title--short">Plateforme AEN</span>
        <span class="iframe-title iframe-title--full">Plateforme d'accompagnement à l'entreprenariat numérique</span>
      </div>

      <div class="header-right">
        <button type="button" class="iframe-btn-back" (click)="close()" aria-label="Retour sur FODE">
          <svg class="iframe-btn-back__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M19 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="iframe-btn-back__label iframe-btn-back__label--full">Retour sur FODE</span>
          <span class="iframe-btn-back__label iframe-btn-back__label--short">Retour sur FODE</span>
        </button>
      </div>
    </div>

    <div class="iframe-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>

    <iframe [src]="iframeUrl | safeUrl" frameborder="0" allow="fullscreen"></iframe>

  </div>
</div>